import React, { useState, useContext } from 'react';
import { ThemeContext } from '../context/theme-context';
import styles from '../styles/Contact.module.css';
import * as emailjs from "@emailjs/browser";
import SubmissionDialog from "./SubmissionDialog";

function Contact() {
    const { theme } = useContext(ThemeContext);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [dialogState, setDialogState] = useState({
        isOpen: false,
        status: 'success'
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.message) newErrors.message = 'Message is required';

        setDialogState({ isOpen: false, status: 'loading' });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setDialogState({ isOpen: true, status: 'loading' });
        if (validateForm()) {
            // Submit form logic
            formData.year = new Date().getFullYear();
            emailjs
                .send(
                    "service_vls1e8g", // Replace with your EmailJS Service ID
                    "template_gikyrie", // Replace with your EmailJS Template ID
                    formData,
                    "KpU407PeDxzqolG2W" // Replace with your EmailJS Public Key
                )
                .then((response) => {
                    setDialogState({ isOpen: true, status: 'success' });
                    setFormData({ name: '', email: '', message: '' });
                })
                .catch((error) => {
                    setDialogState({ isOpen: true, status: 'error', message: 'I\'m sorry, your message was not sent. Please try again later!' });
                });
        }
    };

    const closeDialog = () => {
        setDialogState({ ...dialogState, isOpen: false });
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <section
            className={styles.contactSection}
            id="contact"
            data-theme={theme}
        >
            <div className="container">
                <h2 className="section-title">Contact Me</h2>

                <div className={styles.contactContainer}>
                    <form
                        className={styles.contactForm}
                        onSubmit={handleSubmit}
                    >
                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>Name</label>
                            <input
                                type="text"
                                name="name"
                                className={styles.formInput}
                                value={formData.name}
                                onChange={handleChange}
                            />
                            {errors.name && (
                                <span className={styles.formError}>{errors.name}</span>
                            )}
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>Email</label>
                            <input
                                type="email"
                                name="email"
                                className={styles.formInput}
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors.email && (
                                <span className={styles.formError}>{errors.email}</span>
                            )}
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>Message</label>
                            <textarea
                                name="message"
                                className={styles.formTextarea}
                                value={formData.message}
                                onChange={handleChange}
                                rows={4}
                            />
                            {errors.message && (
                                <span className={styles.formError}>{errors.message}</span>
                            )}

                        </div>

                        <button
                            type="submit"
                            className={styles.submitButton}
                        >
                            Send Message
                        </button>
                    </form>
                    <SubmissionDialog
                        isOpen={dialogState.isOpen}
                        status={dialogState.status}
                        onClose={closeDialog}
                    />
                </div>
            </div>
        </section>
    );
}

export default Contact;